export const USER_RESET = 'USER_RESET';
export const USER_LOGGING = 'USER_LOGGING';
export const USER_FAILED = 'USER_FAILED';
export const USER_SIGNOUT = 'USER_SIGNOUT';
export const ADD_USER = 'ADD_USER';
export const ADD_PORT = 'ADD_PORT';
export const SERIES_RESET = 'SERIES_RESET';
export const SERIES_LOADING = 'SERIES_LOADING';
export const SERIES_FAILED = 'SERIES_FAILED';
export const ADD_SERIES = 'ADD_SERIES';
export const port_metrics_compar_actions = {add:'ADD_PMC', reset:'PMC_RESET', loading:'PMC_LOADING', failed:'PMC_FAILED'};
export const port_backtest_actions = {add:'ADD_BACKTEST', reset:'BACKTEST_RESET', loading:'BACKTEST_LOADING', failed:'BACKTEST_FAILED'};
export const port_tactical_actions = {add:'ADD_TAC', reset:'TAC_RESET', loading:'TAC_LOADING', failed:'TAC_FAILED'};
export const port_optim_actions = {add:'ADD_SAA', reset:'SAA_RESET', loading:'SAA_LOADING', failed:'SAA_FAILED', reset_err:"SAA_RESET_ERRMESS", udt_port:"SAA_UDT_PORT"};
export const port_optim_metrics_actions = {add:'ADD_SAA_METRICS', reset:'SAA_METRICS_RESET', loading:'SAA_METRICS_LOADING', failed:'SAA_METRICS_FAILED', reset_err:"SAA_METRICS_RESET_ERRMESS"};
export const port_optim_exposure_actions = {add:'ADD_SAA_EXP', reset:'SAA_EXP_RESET', loading:'SAA_EXP_LOADING', failed:'SAA_EXP_FAILED', reset_err:"SAA_EXP_RESET_ERRMESS"};
export const funds_select_actions = {add:'ADD_FUNDS', reset:'FUNDS_RESET', loading:'FUNDS_LOADING', failed:'FUNDS_FAILED'};
